import { useCallback } from 'react';
import { useAuth } from '@clerk/clerk-react';

/**
 * Returns an authFetch function that automatically injects the Clerk JWT.
 *
 * Usage:
 *   const { authFetch } = useClerkApi();
 *   const data = await authFetch('/leagues/40774/standings');
 *
 * authFetch merges Authorization: Bearer <token> into every request when a
 * Clerk session is active. Falls back to a plain fetch when no token is
 * available (e.g. public/example pages should use plain fetch directly).
 */
export function useClerkApi() {
  const { getToken } = useAuth();

  const authFetch = useCallback(async (url, options = {}) => {
    const token = await getToken();
    return fetch(url, {
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...(options.headers || {}),
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
    });
  }, [getToken]);

  return { authFetch };
}
